/**
 * Empty state for the dynamic-hint filter panes. Replaces a bare
 * grey label with a centred glyph + caption — the same pattern the
 * rest of the FSD empty states use, so an operator landing on an
 * empty pane immediately recognises it as "nothing here yet" rather
 * than "still loading" or "broken".
 */
const FunnelIcon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <polygon points='22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3' />
  </svg>
);

const NoOptions = ({ title }) => {
  return (
    <div className='qhs-dynh-empty'>
      <span className='qhs-dynh-empty__icon'>
        <FunnelIcon />
      </span>
      {title}
    </div>
  );
};

export default NoOptions;
